import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RestService } from '../../../shared/shared.module';

@Component({
  selector: 'app-user-offer',
  templateUrl: './user-offer.component.html',
  styleUrls: ['./user-offer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserOfferComponent implements OnInit {

  myTemplate: any = '';
  constructor(private restService: RestService) {
    this.restService.urlGet<string>('/assets/Documents/user-offer.html', { responseType: 'text' })
      .then(data =>
        this.myTemplate = data
      );
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/user-offer/user-offer.component.ts